import { render, staticRenderFns } from "./DeleteThoughtDialog.vue?vue&type=template&id=3cfbd764&"
import script from "./DeleteThoughtDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteThoughtDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports